import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@/api/client";
import type { Investment } from "@/types";

export function useInvestments() {
  return useQuery({
    queryKey: ["investments"],
    queryFn: async () => {
      const { data } = await apiClient.get<Investment[]>("/investments");
      return data;
    },
  });
}

/**
 * Upsert por (client_id, fund_id). Substitui o esquema v1 onde cada cliente
 * tinha 1 row com colunas blc_i, blc_ii, ...
 */
export function useUpsertInvestment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: {
      client_id: string;
      fund_id: string;
      amount_brl: number;
      amount_usd: number;
    }) => {
      const { data } = await apiClient.put<Investment>("/investments", payload);
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["investments"] }),
  });
}

export function useDeleteInvestment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.delete(`/investments/${id}`);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["investments"] }),
  });
}
